export default __webpack_public_path__ + "static/media/value-for-money.b7f5e44d.svg";